import "./Stream.scss"

import { toast } from "@skylead/component-library"
import React from "react"
import { VncScreen } from "react-vnc"

import { useGlobalTranslation } from "../../../utils/hook"

const Stream = ({ src, password, onDisconnect, setStreamReady, streamRef }) => {
  const { tt } = useGlobalTranslation()
  const onDisconnectHandler = () => {
    if (streamRef?.current?.rfb?._rfbConnectionState === "disconnected") {
      onDisconnect()
    }
  }
  const copyFromStream = async e => {
    const copy = e.detail.text
    if (copy) {
      const decodedCopy = decodeURIComponent(escape(copy))
      await navigator.clipboard.writeText(decodedCopy)
      toast.success(tt("stream.copy-form-stream.toast.success"))
    }
  }

  return (
    <div className="stream">
      <VncScreen
        url={`wss://${src}`}
        onCredentialsRequired={rfb => rfb.sendCredentials({ username: "skylead", password })}
        onDisconnect={onDisconnectHandler}
        onConnect={rfb => {
          if (rfb && setStreamReady) {
            setStreamReady(true)
          }
        }}
        onClipboard={copyFromStream}
        background="#000000"
        style={{
          width: "1280px",
          height: "720px",
        }}
        ref={streamRef}
        loadingUI={false}
      />
    </div>
  )
}

// Stream.propTypes = {
//   src: PropTypes.string.isRequired,
//   password: PropTypes.string.isRequired,
//   onDisconnect: PropTypes.func.isRequired,
//   streamRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
// }

export default Stream
